// Translation for en
export const kn = {
        common: {
            save: 'Save',
            cancel: 'Cancel',
            close: 'Close',
            delete: 'Delete',
            edit: 'Edit',
            activate: 'Activate',
            add: 'Add',
            saving: 'Saving...',
            loading: 'Loading...',
            active: 'ACTIVE',
            inUse: 'In Use',
            test: 'Test',
            searchApps: 'Search apps...',
            betaBanner: 'BETA - Service not available yet!'
        },
        header: {
            creditBalance: 'Balance',
            minutes: 'MIN'
        },
        auth: {
            signIn: 'Sign In',
            signUp: 'Sign Up',
            username: 'Username',
            password: 'Password',
            continue: 'Continue',
            noAccount: 'Don\'t have an account?',
            hasAccount: 'Already have an account?',
            loginError: 'Login failed',
            invalidCredentials: 'Invalid username or password',
            rateLimited: 'Too many login attempts. Please wait a moment.',
            sessionExpired: 'Your session has expired. Please use a new magic link.',
            magicLinkInvalid: 'The login link is invalid or has expired.',
            magicLinkSuccess: 'Welcome! You have been successfully logged in.',
            magicLinkProcessing: 'Processing login...',
            connectionError: 'Connection error. Please try again.'
        },
        profile: {
            myProgress: 'My Learning Progress',
            signOut: 'Sign Out',
            plan: 'Plan: '
        },
        settings: {
            title: 'Settings',
            tabs: {
                uiSettings: 'UI Settings',
                systemPrompt: 'System Prompt',
                llmProfiles: 'LLM Profiles',
                ttsProfiles: 'TTS Profiles',
                language: 'Language',
            },
            uiSettings: {
                title: 'User Interface',
                themeMode: 'Theme Mode',
                darkMode: 'Dark Mode',
                lightMode: 'Light Mode',
                themeColor: 'Theme Color',
                themeColorDesc: 'Choose the accent color for buttons, icons and highlights',
                background: 'Background',
                backgroundDesc: 'Choose a background for your workspace',
                selectBackgroundColor: 'Select Background Color',
                backgrounds: {
                    cyberSchooling: 'Cyber Schooling',
                    focus: 'Focus',
                    concentration: 'Concentration',
                    relaxation: 'Relaxation',
                    lianas: 'Lianas',
                    color: 'Color'
                },
                backgroundColors: {
                    deepDark: 'Deep Dark',
                    darkGrey: 'Dark Grey',
                    midnightBlue: 'Midnight Blue',
                    indigo: 'Indigo',
                    darkTeal: 'Dark Teal',
                    brown: 'Brown',
                    darkRed: 'Dark Red',
                    deepPurple: 'Deep Purple',
                    pureWhite: 'Pure White',
                    softWhite: 'Soft White',
                    lightGrey: 'Light Grey',
                    paleBlue: 'Pale Blue',
                    paleGreen: 'Pale Green',
                    paleOrange: 'Pale Orange',
                    lavender: 'Lavender',
                    blueGrey: 'Blue Grey'
                }
            },
            systemPrompt: {
                label: 'System Prompt:',
                placeholder: 'Loading system prompt...',
                emptyError: 'System prompt cannot be empty!',
                saveSuccess: '✓ System prompt saved successfully!',
                loadError: 'Error loading system prompt',
                saveError: 'Error saving'
            },
            llmProfiles: {
                addButton: '+ Add New Connection',
                newConnection: 'New Connection',
                editConnection: 'Edit Connection',
                emptyState: 'No LLM connections available. Click below to add one.',
                loadingProfiles: 'Loading profiles...',
                nameLabel: 'Name *',
                namePlaceholder: 'e.g. OpenAI GPT-4',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.openai.com/v1/chat/completions',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelLabel: 'Model *',
                modelPlaceholder: 'gpt-4, mistral-tiny, etc.',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ Profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                profileNotFound: 'Profile not found!',
                loadError: 'Error loading profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting',
                modelInfo: 'Model: {model} | API: {api}'
            },
            ttsProfiles: {
                addButton: '+ Add New Voice',
                newVoice: 'New Voice',
                editVoice: 'Edit Voice',
                emptyState: 'No TTS profiles available. Click below to add one.',
                loadingProfiles: 'Loading TTS profiles...',
                nameLabel: 'Name',
                namePlaceholder: 'e.g. My ElevenLabs Adam',
                providerLabel: 'Provider',
                providerPlaceholder: 'e.g. ElevenLabs, OpenAI, Piper',
                providerPiper: 'Piper (Local)',
                providerOpenAI: 'OpenAI',
                providerElevenLabs: 'ElevenLabs',
                providerAzure: 'Azure',
                apiUrlLabel: 'API URL *',
                apiUrlPlaceholder: 'https://api.example.com/tts',
                apiKeyLabel: 'API Key *',
                apiKeyPlaceholder: 'sk-...',
                modelIdLabel: 'Model ID *',
                modelIdPlaceholder: 'e.g. eleven_monolingual_v1',
                voiceIdLabel: 'Voice ID',
                voiceIdPlaceholder: 'e.g. pNInz6obpgDQGcFmaJgB',
                allFieldsRequired: 'All fields must be filled!',
                saveSuccess: '✓ TTS profile saved successfully!',
                deleteConfirm: 'Do you really want to delete "{name}"?',
                loadError: 'Error loading TTS profiles',
                saveError: 'Error saving',
                activateError: 'Error activating',
                deleteError: 'Error deleting'
            },
            language: {
                title: 'Choose Language',
                description: 'Select your preferred language for the user interface'
            },
        },
        chat: {
            ready: 'Ready',
            start: 'START',
            stop: 'STOP',
            initialMessage: 'Click START for real-time conversation.',
            listening: 'Listening...',
            speaking: 'Thorsten is speaking...',
            userLabel: 'You',
            aiLabel: 'AI',
            modalTitle: 'Thorsten AI Chat',
            inputPlaceholder: 'Type a message...',
            send: 'Send',
            loginRequired: 'Please sign in to use this service.',
            loginButton: 'Sign In Now',
            magicLinkRequired: 'Please use a magic link to sign in.',
            creditLimitError: 'Your hourly quota has been exhausted. Please upgrade your plan (Medium/Premium) to continue.',
            serviceDisabled: 'ಚಾಟ್ ಸೇವೆ ಪ್ರಸ್ತುತ ಲಭ್ಯವಿಲ್ಲ. ದಯವಿಟ್ಟು ನಂತರ ಮತ್ತೆ ಪ್ರಯತ್ನಿಸಿ.'
        },
        notifications: {
            error: 'Error',
            success: 'Success',
            info: 'Information',
            unknownError: 'An unknown error occurred'
        },
        cookie: {
            message: 'This website uses cookies to provide you with the best possible user experience.',
            accept: 'Accept'
        },
        curriculum: {
                buttonLabel: 'ಪಠ್ಯಕ್ರಮ',
                buttonTitle: 'ಪಠ್ಯಕ್ರಮ ವಿಷಯವನ್ನು ತೋರಿಸಿ',
                modalTitle: '{app} ಪಠ್ಯಕ್ರಮ',
                sections: {
                    topic: 'ಪಠ್ಯಕ್ರಮ ವಿಷಯ',
                    explanation: 'ಮಕ್ಕಳಿಗೆ ಅರ್ಥವಾಗುವ ವಿವರಣೆ',
                    studentProfile: 'ವಿದ್ಯಾರ್ಥಿ ಪ್ರೊಫೈಲ್'
                },
                topic: {
                    empty: 'ಈ ಮೈಕ್ರೋ-ಆ್ಯಪ್ಗೆ ಯಾವುದೇ ಪಠ್ಯಕ್ರಮ ವಿಷಯವನ್ನು ಬ್ಯಾಕೆಂಡ್ನಲ್ಲಿ ಲಿಂಕ್ ಮಾಡಲಾಗಿಲ್ಲ.',
                    missingDetail: 'ಈ ಮೈಕ್ರೋ-ಆ್ಯಪ್ಗೆ ವಿವರವಾದ ಪಠ್ಯಕ್ರಮ ಡೇಟಾ ಇನ್ನೂ ಬ್ಯಾಕೆಂಡ್ನಲ್ಲಿ ಲಭ್ಯವಿಲ್ಲ.',
                    learningGoals: 'ಕಲಿಕೆಯ ಗುರಿಗಳು',
                    prerequisites: 'ಪೂರ್ವಾಪೇಕ್ಷಿತೆಗಳು',
                    unitLabel: 'ಘಟಕ',
                    durationLabel: 'ಅವಧಿ',
                    difficultyLabel: 'ಕಷ್ಟದ ಮಟ್ಟ',
                    hours: 'ಗಂ',
                    minutes: 'ನಿ'
                },
                explanation: {
                    empty: 'ಮಕ್ಕಳಿಗೆ ಅರ್ಥವಾಗುವ ವಿವರಣೆ ಲಭ್ಯವಿಲ್ಲ.',
                    loadingPrepare: 'AI ವಿವರಣೆಯನ್ನು ಸಿದ್ಧಪಡಿಸುತ್ತಿದೆ',
                    loadingExplain: 'AI ವಿಷಯವನ್ನು ಮಕ್ಕಳ ಭಾಷೆಯಲ್ಲಿ ವಿವರಿಸುತ್ತಿದೆ',
                    requestFailed: 'ಮಕ್ಕಳಿಗೆ ಅರ್ಥವಾಗುವ ವಿವರಣೆಯನ್ನು ರಚಿಸಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.'
                },
                studentProfile: {
                    country: 'ದೇಶ',
                    region: 'ರಾಜ್ಯ / ಪ್ರದೇಶ',
                    schoolType: 'ಶಾಲೆಯ ಪ್ರಕಾರ',
                    grade: 'ತರಗತಿ',
                    noContext: 'ಯಾವುದೇ ವಿದ್ಯಾರ್ಥಿ ಸಂದರ್ಭ ಲಭ್ಯವಿಲ್ಲ.',
                    childProfileNotFound: 'ಪ್ರಸ್ತುತ ಲಾಗಿನ್ಗೆ ಬ್ಯಾಕೆಂಡ್ನಲ್ಲಿ ಯಾವುದೇ ವಿದ್ಯಾರ್ಥಿ ಪ್ರೊಫೈಲ್ ಕಂಡುಬಂದಿಲ್ಲ.',
                    loginProfileIncomplete: 'ಲಾಗಿನ್ ಪ್ರೊಫೈಲ್ ಇನ್ನೂ ಸಂಪೂರ್ಣ ವಿದ್ಯಾರ್ಥಿ ಸಂದರ್ಭವನ್ನು ಹೊಂದಿಲ್ಲ.',
                    educationContextNotFound: 'ವಿದ್ಯಾರ್ಥಿ ಪ್ರೊಫೈಲ್ ಕಂಡುಬಂದಿದೆ, ಆದರೆ ಯಾವುದೇ ಪಠ್ಯಕ್ರಮ ನಿಯೋಜನೆಯನ್ನು ಹೊಂದಿಸಲಾಗಿಲ್ಲ.',
                    noToken: 'ಯಾವುದೇ ಸೈನ್-ಇನ್ ಮಾಡಿದ ವಿದ್ಯಾರ್ಥಿ ಕಂಡುಬಂದಿಲ್ಲ.'
                },
                errors: {
                    signInRequired: 'ಪಠ್ಯಕ್ರಮವನ್ನು ವೀಕ್ಷಿಸಲು ದಯವಿಟ್ಟು ಸೈನ್ ಇನ್ ಮಾಡಿ.',
                    appIdMissing: 'ಆ್ಯಪ್ ID ಕಾಣೆಯಾಗಿದೆ.',
                    loadFailed: 'ಪಠ್ಯಕ್ರಮ ಡೇಟಾವನ್ನು ಲೋಡ್ ಮಾಡಲು ಸಾಧ್ಯವಾಗಲಿಲ್ಲ.'
                }
            }
    };
